import SearchIcon from "components/icons/SearchIcon";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {
    MdAdd, MdAddCircle, MdAddCircleOutline, MdCancel,
    MdChevronLeft,
    MdChevronRight,
    MdDownload,
    MdDownloadForOffline, MdOutlineCloudUpload,
    MdOutlineFileDownload, MdOutlineFileUpload, MdSave,
    MdUploadFile
} from "react-icons/md";
import {useGlobalFilter, usePagination, useSortBy, useTable,} from "react-table";
import {DiAndroid, DiApple} from "react-icons/di";
import {utils, writeFile} from "xlsx";
import axios from "axios";
import {AES, enc} from "crypto-js";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as xlsx from "xlsx";
import {useDropzone} from "react-dropzone";
import {useNavigate} from "react-router-dom";

function FaqDataTable(props) {
    const {columnsData, tableData, productId} = props;

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/LAPI/"
    const secretKey = "cromptonssecretkey";
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);
    let [addNewFaq, setAddNewFaq] = useState(false)

    let [userEditable, setUserEditable] = useState(false);
    let [acl, setAcl] = useState("")
    const fileExtension = ".xlsx";
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const [message, setMessage] = useState("");
    let requestBody = [];
    const [chosenFile, setChosenFile] = useState(null);

    let [jsonRequestBody, setJsonRequestBody] = useState([]);
    const navigate = useNavigate();
    let [question, setQuestion] = useState("");
    let [answer, setAnswer] = useState("");

    let [placeHolderQuestion, setPlaceHolderQuestion] = useState("Enter Question...");
    let [placeHolderAnswer, setPlaceHolderAnswer] = useState("Enter Answer...");

    function convertGMTtoIST(gmtDateTime) {
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Return the IST date and time in DD/MM/YYYY HH:MM format
        return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
    }

    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function exportFaqData() {
        let filteredData

        filteredData = data.map((item) => ({
            Question: item.question,
            Answer: item.answer
        }));

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_faq_details")
        writeFile(wb, "faq_" + productId + "_" + getCurrentDate() + ".xlsx")
    }

    function exportFaqTemplate(apiData, fileName) {
        const ws = XLSX.utils.json_to_sheet(apiData);
        /* custom headers */
        XLSX.utils.sheet_add_aoa(ws, [["Category", "Question", "Answer"]], {origin: "A1"});
        const wb = {Sheets: {data: ws}, SheetNames: ["FAQ Template"]};
        const excelBuffer = XLSX.write(wb, {bookType: "xlsx", type: "array"});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    const worksheet = XLSX.utils.json_to_sheet([
        // Your template data here
        {
            category: 'Category',
            question: 'Question',
            answer: 'Answer'
        },
    ]);

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            //console.log(error.message);
        }
    }


    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FAQ Template');

    const handleExportClick = () => {
        XLSX.writeFile(workbook, 'faq_import_template.xlsx');
    };

    function modifyUserAccessLevelApi(emailPhone, acl) {
        var bodyFormData;
        let index = emailPhone.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobile: emailPhone,
                acl: acl
            }
        } else {
            bodyFormData = {
                email: emailPhone,
                acl: acl
            }
        }
        //console.log(bodyFormData)
        return axios({
            method: 'put',
            url: CROMPTON_URL + 'user/updateAcl',
            data: bodyFormData,
            headers: {
                Authorization: decryptedValue,
            }
        }).then(response => {
            // console.log(response)
            window.location.reload()

        })
            .catch(
                error => {
                    // console.log(error)
                }
            )
    }

    function formatData(dataString) {
        // Split the data string at each colon and trim leading/trailing spaces
        const dataLines = dataString.split(':').map(line => line.trim());
        // Join with line breaks
        return dataLines.join('\n');
    }

    const importFaqTemplate = (e) => {
        //console.log("Inside")
        //console.log(e)
        e.preventDefault();
        if (e.target.files) {
            const fileType = e.target.files[0].type;

            if (fileType !== 'application/vnd.ms-excel' && fileType !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setMessage("The file type is invalid. Please upload file with .xls or .xlsx extension")
                return; // Prevent further processing if file type is invalid
            } else if (e.target.files[0].size === 0) {
                setMessage("The file uploaded is empty!!!!")
                return
            }
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = xlsx.read(data, {type: "array"});
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);

                /*json.forEach((jsonObject) => {
                    jsonObject.productId = productId;
                });

                //console.log(json);

                for (let i = 0; i < json.length; i++) {
                    requestBody.push(json[i]);
                    //setFaqApiCall(json[i])
                }*/

                //console.log(requestBody)
                //setJsonRequestBody(requestBody)
                const lowercaseKeys = (obj) => {
                    return Object.keys(obj).reduce((acc, key) => {
                        acc[key.toLowerCase()] = obj[key];
                        return acc;
                    }, {});
                };

                const normalizedJson = json.map((jsonObject) => ({
                    ...lowercaseKeys(jsonObject),
                    productId: productId
                }));

                setJsonRequestBody(normalizedJson);
                //console.log(normalizedJson);


                setMessage("")
            };
            reader.readAsArrayBuffer(e.target.files[0]);
            setChosenFile(e.target.files[0])
            //console.log(e.target.files[0])

        }
    }

    function uploadFaqsToCloud() {
        //console.log(jsonRequestBody)
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'faq/add/multiple',
            data: jsonRequestBody,
            headers: {
                Authorization: decryptedValue
            }
        }).then(response => {
            //console.log("Response: ", response)
            if (response.status === 200) {
                setMessage("FAQs updated successfully")
                window.location.reload()
                //sessionStorage.setItem("location", location)
            }
            if (response.status === 208) {
                setMessage(response.data.message)
            }
        })
            .catch(
                error => {
                    //console.log("E2", error.response.data.message)
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    } else if (error.response.data.status === "500") {
                        setMessage("Please check the uploaded file is as per template")
                    } else {
                        setMessage(error.response.data.message)
                        //setError(error)
                        return error
                    }
                }
            )

    }

    function uploadSingleFaq() {
        //console.log(jsonRequestBody)
        let formData = {
            category: "Device",
            question: question,
            answer: answer,
            productId: productId
        }

       // console.log(formData)
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'faq/add',
            data: formData,
            headers: {
                Authorization: decryptedValue
            }
        }).then(response => {
           // console.log("Response: ", response)
            if (response.status === 200) {
                setMessage("FAQs updated successfully")
                //window.location.reload()
                //sessionStorage.setItem("location", location)
            }
            if (response.status === 208) {
                setMessage(response.data.message)
            }
        })
            .catch(
                error => {
                   // console.log("E2", error.response.data.message)
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    } else if (error.response.data.status === "500") {
                        setMessage("Please check the uploaded file is as per template")
                    } else {
                        setMessage(error.response.data.message)
                        //setError(error)
                        return error
                    }
                }
            )

    }

    const onDrop = async acceptedFiles => {
        //console.log("Inside")
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            //console.log("Inside")
            //console.log(file.type)

            // Check for valid image types (optional)
            const validImageTypes = ['image/jpeg', 'image/png'];
            if (!validImageTypes.includes(file.type)) {
                //console.error('Invalid image type. Please upload a JPEG or PNG file.');
                setMessage('Invalid image type. Please upload a JPEG or PNG file.')
                return;
            }

            // Check for size limit (optional)
            if (file.size > 1048576) {  // 1 MB
                setMessage('Image size exceeds 1 MB limit.')
                //console.error('Image size exceeds 1 MB limit.');
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read image as data URL

            reader.onload = (e) => {
                const dataURL = e.target.result;
                const filename = file.name;

                // Store filename and dataURL in session storage
                sessionStorage.setItem('uploadedImageFilename', filename);
                sessionStorage.setItem('uploadedImageFile', dataURL);
            };

            /*getImageResolution(file)
                .then(async (resolution) => {
                    //console.log(`Image resolution: ${resolution.width} x ${resolution.height}`);

                    if (resolution.width === TARGET_WIDTH && resolution.height === TARGET_HEIGHT) {
                        setErrorMessage("")
                        setSelectedFile(file);
                        selectedFile = file


                        const base64String = await toBase64(file);
                        sessionStorage.setItem("updatedProductImage", base64String);
                        sessionStorage.setItem("updatedProductImageName", file.name);
                    } else {
                        setErrorMessage("Please upload file of 80*80 dimensions")
                    }

                })
                .catch((error) => {
                    console.error('Error getting image resolution:', error);
                });*/

        }
    };

    const {getRootProps, getInputProps} = useDropzone({onDrop});

    const handleRemoveFile = () => {
        //console.log("remove file")
        setChosenFile(null);
        const fileInput = document.getElementById('fileInput'); // Get reference to file input
        fileInput.value = ''; // Reset the value to trigger a fresh selection dialog
    };

    const handleQuestionChange = (event) => {
        //console.log(event)
        setQuestion(event.target.value);
    };

    const handleAnswerChange = (event) => {
        //console.log(event)
        setAnswer(event.target.value);
    };


    return (
        <div className="h-full w-full">
            {/* Search */}
            <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                FAQs: Frequently Asked Questions
            </h2>
            <div
                className="mx-auto mt-5 flex w-full gap-1 overflow-hidden md:!gap-6 xl:w-[100%] flex-col sm:flex-row justify-between">
                <div
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    className="flex w-[350px] max-w-full items-center rounded-xl p-[8px] pt-[20px] xl:ml-3 md:w-[800px] xl:w-fill">
                    <div
                        className="flex h-[38px] w-[400px] flex-grow items-center rounded-xl bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900 dark:text-white">
                        <SearchIcon className="dark:text-white"/>
                        <input
                            type="text"
                            placeholder="Search...."
                            className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
                        />
                    </div>
                </div>

                <div className="flex flex-row">
                    <button
                        className=" mb-3 flex items-center justify-center text-sm font-bold rounded-xl p-1 border !border-gray-200 text-navy-700 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                        onClick={handleExportClick}>
                        <MdDownload/>
                        &nbsp;  Download Template
                    </button>
                    {/*<button className="h-full !w-full">
                        <input {...getInputProps()}  />
                        <div
                            className="flex h-[50px] w-full flex-col items-center justify-center rounded-xl border-[1px] border-dashed border-gray-200 bg-gray-100
        dark:!border-none dark:!bg-navy-700 sm:w-[200px] md:w-[285px] lg:w-[350px] xl:w-[300px] 2xl:w-[345px] 3xl:w-[340px]">
                            <p className="text-[80px] text-navy-700">
                                <MdOutlineCloudUpload className="text-[#004c86] dark:text-white"/>
                            </p>
                            <p className="text-lg font-bold text-navy-700 dark:text-white">
                                Drop your files here, or{" "}
                                <span className="font-bold text-[#004c86] dark:text-[#0b83b5]">
                    browse
                </span>
                            </p>
                            <p className="pt-2 text-sm text-gray-600">
                                PNG and JPG files are allowed. Upload an image of 80*80 pixels.
                            </p>
                        </div>
                    </button>*/}
                    <button
                        className=" mb-3 flex items-center justify-center text-sm font-bold rounded-xl border p-1 !border-gray-200 text-navy-700 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                        onClick={exportFaqData}>
                        <MdOutlineFileDownload/>
                        &nbsp; Download FAQs
                    </button>

                    {chosenFile === null ?
                        <div className="button-container flex flex-row">
                            <button
                                className=" mb-3 flex items-center justify-center text-sm font-bold rounded-xl p-1 border !border-gray-200 text-navy-700 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                                onClick={() => document.getElementById('fileInput').click()}>
                                <MdUploadFile/>
                                &nbsp;  Upload FAQ Excel
                            </button>
                            <input
                                id="fileInput"
                                type="file"
                                accept=".xlsx, .xlsm, .xlsb" // Add accepted Excel file extensions
                                style={{display: 'none'}} // Hide the input element
                                onChange={importFaqTemplate} // Function to handle file selection
                                disabled={chosenFile !== null}/>
                            <span className="remove-icon" onClick={handleRemoveFile}
                                  hidden={true}>&times;</span>
                        </div>
                        :
                        <div className="button-container flex flex-row">
                            <p className="text-sm font-medium text-blue-800 md:text-base cursor-pointer text-center content-center"
                               onClick={handleRemoveFile}
                               hidden={false}>&times; &nbsp; {chosenFile.name} &nbsp; &nbsp;</p>
                            <button
                                className="mb-3 flex items-center justify-center text-sm font-bold rounded-xl p-1 border !border-gray-200 text-navy-700 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                                hidden={chosenFile === null}
                                disabled={chosenFile === null}
                                onClick={uploadFaqsToCloud}>
                                <MdOutlineFileUpload/>
                                &nbsp; Upload Data
                            </button>
                        </div>

                    }

                </div>
            </div>


            <span className="errorMessage items-center flex justify-content: center align-items: center flex-col">
                {message}
            </span>

            {/* table */
            }
            <div className="mt-[25px] overflow-x-scroll 2xl:overflow-x-hidden">
                <table {...getTableProps()} className="mt-8 h-max w-full" variant="simple" color="gray-500" mb="24px">
                    <thead className="w-full">
                    {headerGroups.map((headerGroup, index) => (
                        <tr
                            className="items-center border-b border-gray-200 text-base dark:border-white/10"
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                        >
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    className="border-b border-gray-200 pr-32 pb-[10px] text-start dark:!border-navy-700"
                                    key={index}
                                >
                                    <div className="text-xs font-bold tracking-wide text-gray-600">
                                        {column.render("Header")}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map((row, indexPage) => {
                        prepareRow(row);
                        return (
                            <tr className="border-b border-gray-200 dark:!border-white/10"
                                {...row.getRowProps()}
                                key={indexPage}>
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    switch (cell.column.Header) {
                                        case "SR":
                                            data = (
                                                <div
                                                    className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {(currentPage * pageSize) + (indexPage + 1)}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        /*case "CATEGORY":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break*/
                                        case "QUESTION":
                                            data = (
                                                <div className="flex items-center gap-2 mr-5">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "ANSWER" :
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {(cell.value)}
                                                    </p>
                                                </div>
                                            );
                                            break

                                        /*case "ACTIONS": {
                                            !userEditable ?
                                                data = (
                                                    <button
                                                        className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                        onClick={() => editUserAccess(cell.row.original)}
                                                        id="editButton">
                                                        <MdEdit onClick={() => editUserAccess(cell.row.original)}/>
                                                    </button>
                                                ) :
                                                data = (
                                                    <button
                                                        className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 grid grid-cols-2 gap-2 items-center"
                                                        id="editButton">
                                                        <MdOutlineSave className="text-green-800 "
                                                                       onClick={() => saveUserAccess(cell.row.original)}/>
                                                        <MdOutlineCancel className="text-red-800"
                                                                         onClick={editingCancel}/>
                                                    </button>
                                                )
                                        }*/
                                    }
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                            key={index}
                                            className="pt-[14px] pb-[16px] sm:text-[14px]">
                                            {data}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    {!addNewFaq &&
                        <tr className="border-b border-gray-200 dark:!border-white/10">
                            <td className="text-center pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    <p className="text-sm font-bold tracking-wide text-gray-600 cursor-pointer">

                                    </p>
                                </div>
                            </td>
                            <td className="text-center pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    <p className="text-sm font-bold tracking-wide text-gray-600 cursor-pointer">

                                    </p>

                                </div>
                            </td>

                            <td className="text-center pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2 " onClick={() => setAddNewFaq(true)}>
                                    <p className="text-sm font-bold tracking-wide text-gray-600 cursor-pointer">
                                        Add New FAQ
                                    </p>
                                    <MdAddCircleOutline className="text-gray-600 font-bold"/>
                                </div>
                            </td>
                        </tr>
                    }

                    {addNewFaq &&
                        <tr className="border-b border-gray-200 dark:!border-white/10">
                            <td className="text-center pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    <input className="text-sm font-bold tracking-wide text-gray-600" type={"text"}
                                       onChange={(e) => handleQuestionChange(e)} placeholder={placeHolderQuestion}>

                                    </input>
                                </div>
                            </td>
                            <td className="text-center pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    <input className="text-sm font-bold tracking-wide text-gray-600" type={"text"}
                                           onChange={(e) => handleAnswerChange(e)} placeholder={placeHolderAnswer}>

                                    </input>
                                </div>
                            </td>
                            <td className="text-center pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    <p className="text-sm font-bold tracking-wide cursor-pointer text-green-800" onClick={uploadSingleFaq}>
                                        Save
                                    </p>
                                    <MdSave className="text-green-800 font-bold" onClick={uploadSingleFaq}/>
                                    <p>

                                    </p>
                                    <p className="text-sm font-bold tracking-wide text-gray-600 cursor-pointer"
                                       onClick={() => setAddNewFaq(false)}>
                                        Cancel
                                    </p>
                                    <MdCancel className="text-gray-600 font-bold" onClick={() => setAddNewFaq(false)}/>
                                </div>
                            </td>
                        </tr>
                    }


                    </tbody>
                </table>
            </div>
            {/* pagination */
            }
            {
                !userEditable &&
                <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                    {/* left side */}
                    <div className=" flex items-center gap-3">
                        <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                            Show rows per page{" "}
                        </p>
                        <select
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                            name=""
                            id=""
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div className="flex items-center gap-4">
                        <p className="text-sm font-bold text-gray-700 dark:text-white">
                            Page {currentPage + 1} of {totalPages}
                        </p>
                    </div>
                    {/* right side */}
                    <div className="flex items-center gap-3">
                        {state.pageIndex !== 0 && (
                            <button
                                onClick={previousPage}
                                disabled={state.pageIndex === 0}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronLeft/>
                            </button>
                        )}
                        <p className="text-sm text-gray-700 font-bold dark:text-white ">
                            {currentPage + 1}
                        </p>
                        {state.pageIndex !== totalPages - 1 && (
                            <button
                                onClick={nextPage}
                                disabled={state.pageIndex === totalPages}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronRight/>
                            </button>
                        )}
                    </div>
                </div>
            }


        </div>


    )
        ;
}

export default FaqDataTable;

